export const ROUTES = {
  OFFER: 'recycling_funnel_device_offer',
  CATEGORY: 'recycling_funnel_category',
}
